import React from "react";
import {
  FaCheckCircle,
  FaSpinner,
  FaBoxes,
  FaUsers,
  FaLaptopCode,
  FaCogs,
} from "react-icons/fa";

const stats = [
  {
    title: "Completed Projects",
    value: 120,
    icon: <FaCheckCircle className="text-green-500 text-4xl" />,
    description: "Successfully delivered across multiple industries.",
  },
  {
    title: "Ongoing Projects",
    value: 8,
    icon: <FaSpinner className="text-yellow-500 text-4xl animate-spin" />,
    description: "In progress with agile methodology and client feedback.",
  },
  {
    title: "SaaS Products Delivered",
    value: 34,
    icon: <FaBoxes className="text-blue-500 text-4xl" />,
    description: "Tailored platforms with user-first design.",
  },
  {
    title: "Clients Served",
    value: 45,
    icon: <FaUsers className="text-purple-500 text-4xl" />,
    description: "Long-term partnerships built on trust and delivery.",
  },
  {
    title: "Web & Mobile Apps",
    value: 62,
    icon: <FaLaptopCode className="text-pink-500 text-4xl" />,
    description: "Built using React, Node.js, Flutter and more.",
  },
  {
    title: "Custom Integrations",
    value: 76,
    icon: <FaCogs className="text-orange-500 text-4xl" />,
    description: "Integrated with APIs, ERPs, CRMs & payment gateways.",
  },
];

const ProjectOverview = () => {
  return (
    <section className="py-12 bg-base-200">
      <div className="mx-auto max-w-6xl px-5 lg:p-0">
        <div className="text-center">
          <div className="divider text-xl py-5">
            <h1 className="mx-auto text-4xl font-bold my-3">
              Our Achievements
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="bg-base-100 p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center justify-center mb-4">
                {stat.icon}
              </div>
              <h3 className="text-3xl font-bold text-primary text-center">
                {stat.value}
              </h3>
              <p className="mt-2 text-xl font-semibold text-center">
                {stat.title}
              </p>
              <p className="text-center text-gray-400 mt-1">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectOverview;
